var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1956 16.8119L17.2663 16.7412L17.1956 16.6705L12.5397 12.0146C13.6517 10.6437 14.2042 8.90145 14.0838 7.13809C13.9614 5.34434 13.1521 3.66684 11.8243 2.45456C10.4966 1.24229 8.75256 0.588578 6.95509 0.62942C5.15762 0.670262 3.4451 1.40251 2.17377 2.67384C0.902436 3.94517 0.170186 5.6577 0.129344 7.45517C0.0885019 9.25264 0.742213 10.9967 1.95449 12.3244C3.16676 13.6522 4.84426 14.4615 6.63802 14.5839C8.40137 14.7043 10.1436 14.1518 11.5146 13.0398L16.1704 17.6957L16.2411 17.7664L16.3119 17.6957L17.1956 16.8119ZM1.59989 7.62497C1.59989 6.53222 1.92392 5.46402 2.53102 4.55544C3.13811 3.64686 4.001 2.93871 5.01056 2.52053C6.02012 2.10236 7.13102 1.99294 8.20276 2.20613C9.27451 2.41931 10.259 2.94552 11.0317 3.7182C11.8043 4.49089 12.3305 5.47535 12.5437 6.54709C12.7569 7.61884 12.6475 8.72973 12.2293 9.73929C11.8112 10.7489 11.103 11.6117 10.1944 12.2188C9.28586 12.8259 8.2177 13.1499 7.125 13.15C5.66015 13.1483 4.25576 12.5657 3.21995 11.5299C2.18417 10.4941 1.60154 9.08978 1.59989 7.62497Z",
    fill: "#767676",
    stroke: "#767676",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8dd8c4d1.svg";
export { ForwardRef as ReactComponent };